/* Progressive enhancement only; no tracking, remote calls or cart mutation. */
(() => {
  'use strict';
  const init = (root = document) => {
    root.querySelectorAll('[data-nl-menu]').forEach(menu => {
      if (menu.dataset.premiumBound) return;
      menu.dataset.premiumBound = 'true';
      const trigger = menu.querySelector('summary');
      if (!trigger) return;
      const sync = () => trigger.setAttribute('aria-expanded', String(menu.open));
      sync(); menu.addEventListener('toggle', sync);
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault(); menu.open = false; sync(); trigger.focus();
      });
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('[data-nl-menu]').forEach(other => {
          if (other !== menu) other.open = false;
        });
      });
    });
    root.querySelectorAll('[data-nl-toc]').forEach(toc => {
      if (toc.dataset.premiumBound) return;
      const body = document.getElementById(toc.dataset.contentId || '');
      const list = toc.querySelector('ol');
      if (!body || !list) return;
      toc.dataset.premiumBound = 'true';
      const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
      if (headings.length < 2) return;
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = `${body.id}-section-${index + 1}`;
          while (document.getElementById(id)) id += '-h';
          heading.id = id;
        }
        heading.tabIndex = -1;
        const li = document.createElement('li'), a = document.createElement('a');
        a.href = `#${encodeURIComponent(heading.id)}`; a.textContent = heading.textContent.trim();
        a.addEventListener('click', () => requestAnimationFrame(() => heading.focus({preventScroll:true})));
        li.append(a); list.append(li);
      });
      toc.hidden = false;
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-nl-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
